import React from "react";
import { connect } from "react-redux";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import VpnKey from "@material-ui/icons/VpnKey";

import Button from "common/components/CustomButtons/Button.jsx";

import config from "config.js";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  buttonBox: {
    display: "flex",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
};

const handlePasswordChange = () => {
  window.location.replace(
    config.AUTH.ADDRESS +
      config.AUTH.APP_PATH +
      "?r=" +
      (process.env.NODE_ENV === "development" ? "myaccountdev" : "myaccount") +
      "&route=changepassword",
  );
};
/*
const handleU2f = () => {
  window.location.replace(
    config.AUTH.ADDRESS +
      config.AUTH.APP_PATH +
      "?r=" +
      (process.env.NODE_ENV === "development" ? "myaccountdev" : "myaccount") +
      "&route=registeru2f"
  );
};
*/

const AccountSecurityCard = (props) => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <VpnKey />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Account security</h4>
      </CardHeader>
      <CardBody className={classes.buttonBox}>
        <GridContainer align="center" justify="center">
          <GridItem xs={12}>
            <br />
            <br />

            <h5 className={classes.cardTitle}>
              These changes will apply to {props.userEmail}
            </h5>
            <br />
          </GridItem>
          <GridItem>
            <Button
              className={classes.buttonStyle}
              color="primary"
              onClick={handlePasswordChange}
            >
              Change password
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  userEmail: state.services.ids.email,
});
export default withStyles(styles)(
  connect(mapStateToProps)(AccountSecurityCard),
);
